import { render, staticRenderFns } from "./MenuUsuarioUnidade.vue?vue&type=template&id=1168d60c&"
import script from "./MenuUsuarioUnidade.vue?vue&type=script&lang=js&"
export * from "./MenuUsuarioUnidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports